<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  .mapping-grid {
    display: grid;
    gap: utils.in_rem(25px);
    padding: utils.in_rem(32px) 0 utils.in_rem(32px) utils.in_rem(50px);

    .map {
      display: grid;
      gap: utils.in_rem(12px);
    }

    .social-urls-header {
      @include mixins.h3();
    }

    .show-more {
      display: flex;
      justify-content: center;
      justify-self: center;
      width: fit-content;
    }
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import FieldMultiMappingRow from "./MappingGrid/FieldMultiMappingRow.svelte";
  import FieldSingleMappingRow from "./MappingGrid/FieldSingleMappingRow.svelte";
  import SettingMappingRow from "./MappingGrid/SettingMappingRow.svelte";

  import { integrationStore, isDataRefreshTab } from "../../stores";

  export let syncAs;

  $: fields = $isDataRefreshTab
    ? $integrationStore.getDataRefreshFields()
    : $integrationStore.getFields(syncAs);

  let showMore = false;
  const handleShowMore = () => {
    showMore = !showMore;
  };

  const visibleUrlKeys = [
    "facebookUrl",
    "linkedinUrl",
    "githubUrl",
    "twitterUrl",
    "xingUrl",
    "youtubeUrl",
  ];

  $: strFields = fields
    .filter(
      (f) =>
        f.type === "str" ||
        (f.type === "list" &&
          typeof $integrationStore.getFieldValue(`${f.key}[]`, syncAs) ===
            "string")
    )
    .sort((a, b) => a.title.localeCompare(b.title));
  $: listFields = fields
    .filter(
      (f) =>
        f.type === "list" &&
        typeof $integrationStore.getFieldValue(`${f.key}[]`, syncAs) !==
          "string"
    )
    .sort((a, b) => a.title.localeCompare(b.title));
  $: visibleUrlFields = fields
    .filter((f) => f.type === "url" && visibleUrlKeys.includes(f.key))
    .sort(
      (a, b) => visibleUrlKeys.indexOf(a.key) - visibleUrlKeys.indexOf(b.key)
    );
  $: accordionUrlFields = fields
    .filter((f) => f.type === "url" && !visibleUrlKeys.includes(f.key))
    .sort((a, b) => a.title.localeCompare(b.title));
</script>

<div class="mapping-grid">
  <SettingMappingRow
    sourceLabel="SourceWhale"
    targetLabel={$integrationStore.getProviderTitle()}
    header
  />
  <div class="map">
    {#each strFields as field}
      <FieldSingleMappingRow {field} {syncAs} />
    {/each}
    {#each listFields as field}
      <FieldMultiMappingRow {field} {syncAs} />
    {/each}
    {#if !$isDataRefreshTab}
      <span class="social-urls-header">Social URLs</span>
      {#each visibleUrlFields as field}
        <FieldSingleMappingRow {field} {syncAs} />
      {/each}
      {#if showMore}
        {#each accordionUrlFields as field}
          <FieldSingleMappingRow {field} {syncAs} />
        {/each}
      {/if}
      <div class="show-more">
        <Button
          onclick={handleShowMore}
          kind="ghost-blue"
          leadingIcon={showMore ? "" : "far fa-plus"}
        >
          {#if showMore}
            Show less
          {:else}
            Show more
          {/if}
        </Button>
      </div>
    {/if}
  </div>
</div>
